import { createAction, props } from '@ngrx/store';

export const setFilterCount = createAction(
  '[Shared] Set Filter Count',
  props<{ filterCount: number }>(),
);
